import React, { useState, useEffect, useRef, useLayoutEffect } from 'react';
import { useEventListener } from '@react-hooks-library/core'
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Fab from '@mui/material/Fab';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import ListSubheader from '@mui/material/ListSubheader';
import Checkbox from '@mui/material/Checkbox';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import CircularProgress from '@mui/material/CircularProgress';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Chip from '@mui/material/Chip';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/SearchRounded';
import Divider from '@mui/material/Divider';
import Badge, { badgeClasses } from '@mui/material/Badge';
import Slider from '@mui/material/Slider';
import FeedContentsTable from './tables/FeedContentsTable';
import { useSelector, useDispatch } from 'react-redux'
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import endpoints, { getBackendUrl } from '../../endpoints';
import {storage} from '../../storage';
import axios from 'axios';
import withAlert from '../../hoc/withAlerts'
import Loading from '../pages/parts/Loading'
import Stack from '@mui/material/Stack';
import BasicModal from './modals/BasicModal'
import AddTagForm from './forms/AddTagForm';
import { setHeader, clearHeader } from '../../redux/headerSlice'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import EditFeedModal from './modals/EditFeedModal'
import ErrorBoundary from './parts/ErrorBoundary'
import EditIcon from '@mui/icons-material/EditRounded';
import DownloadIcon from '@mui/icons-material/DownloadRounded';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutlineRounded';
import RefreshIcon from '@mui/icons-material/RefreshRounded';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpwardRounded';
import Confirmation from './modals/Confirmation';
import Information from './modals/Information';
import Tooltip from '@mui/material/Tooltip';
import Fade from '@mui/material/Fade';

const HEADER_HEIGHT = 57

let rssId
let sessionStartId = null
let loadingNextPage = false
let loadingFinish = false

function FeedContents(props) {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate()
    
    let params = useParams();
    rssId = params.id;
    
    const [scrollUpBtn, setScrollUpBtn] = useState(false)

    const [loading, setLoading] = useState(false)
    const [tagsList, setTagsList] = useState([])
    const [list, setList] = useState([])
    const [total, setTotal] = useState(null)
    const [feed, setFeed] = useState();
    const [modalAddOpen, setModalAddOpen] = useState(false);
    const [filterTags, setFilterTags] = useState(storage.contents.filterTags);
    const [filterSearch, setFilterSearch] = useState(storage.contents.filterSearch);
    const [filterFrom, setFilterFrom] = useState(storage.contents.filterFrom);
    const [filterTo, setFilterTo] = useState(storage.contents.filterTo);
    const [filterType, setFilterType] = useState(storage.contents.filterType);
    const [filterReadability, setFilterReadability] = useState(storage.contents.filterReadability || 'unread');
    const [test, setTest] = useState(storage.contents.test || 'on');
    const [previewLines, setPreviewLines] = useState(() => {
        const stored = Number(localStorage.getItem('contentsPreviewLines'));
        return stored || storage.contents.previewLines || 4;
    });
    const [appendAfterReload, setAppendAfterReload] = useState(0)
    const [suitableThreshold, setSuitableThreshold] = useState()
    const [aiEnabled, setAiEnabled] = useState(false)
    
    const scrollYRef = useRef(null);
    const [viewContentId, setViewContentId] = useState(null)
    
    const [analyzeItem, setAnalyzeItem] = useState();
    const [feedItem, setFeedItem] = useState();
    const [loadFeeds, setLoadFeeds] = useState();
    const [showInformation, setShowInformation] = useState(false)
    const [wssUpdateContents, setWssUpdateContents] = useState([])
    
    const applyBtn = useRef();

    const token = useSelector((state) => state.auth.token);
    const dispatch = useDispatch();
    
    const withoutTagsLabel = 'No any Tags';
    
    let scrollTimeout = null
    
    useEffect(() => {
        getList()
    }, [filterTags, filterSearch, filterFrom, filterTo])
    
    const getTagsList = async () => {
        let items = []
        
        let uri = ''
        let res = null
        
        // Owners  -----------------
        uri = getBackendUrl(endpoints.settings, token).replace('{name}', 'FEED_CONTENT_OWNERS')
        try {
            res = await axios.get(uri)
            items.push({
                id: null,
                type: 'subheader',
                name: 'Owners'
            })
            items = items.concat(res.data.value?.split("\n").map((item) => {
                return {
                    id: 'o_' + item,
                    type: 'owner',
                    name: item
                }
            }))
        } catch (e) {
            showAlertError('Unknown Error - get tags list')
        }
        
        // Profiles  ---------------
        uri = getBackendUrl(endpoints.settings, token).replace('{name}', 'FEED_CONTENT_PROFILES')
        try {
            res = await axios.get(uri)
            items.push({
                id: null,
                type: 'subheader',
                name: 'Profiles'
            })
            items = items.concat(res.data.value?.split("\n").map((item) => {
                return {
                    id: 'p_' + item,
                    type: 'profile',
                    name: item
                }
            }))
        } catch (e) {
            showAlertError('Unknown Error - get tags list')
        }
        
        // Sent  --------------------
        items.push({
            id: null,
            type: 'subheader',
            name: 'Sent'
        })
        items.push({
            id: 's_sent',
            type: 'sent',
            name: 'Sent'
        })
        items.push({
            id: 's_notsent',
            type: 'sent',
            name: 'Not Sent'
        })
        
        // Tags  -------------------
        uri = getBackendUrl(endpoints.tags, token)
        try {
            res = await axios.get(uri)
            items.push({
                id: null,
                type: 'subheader',
                name: 'Tags'
            })
            items = items.concat(res.data.items.map((item) => {
                return {
                    id: 't_' + item.id,
                    type: 'tag',
                    name: item.name
                }
            }))
        } catch (e) {
            showAlertError('Unknown Error - get tags list')
        }
        // --------------------------
        
        setTagsList(items)
    }

    const getSuitableThreshold = async () => {
        const uri = getBackendUrl(endpoints.settings, token).replace('{name}', 'SUITABLE_THRESHOLD')
        try {
            const res = await axios.get(uri)
            setSuitableThreshold(parseInt(res.data.value) ?? 70)
        } catch (e) {
            showAlertError('Unknown Error - get Suitable Threshold')
        }
    }

    const getAiEnabled = async () => {
        const uri = getBackendUrl(endpoints.settings, token).replace('{name}', 'AI_ENABLED')
        try {
            const res = await axios.get(uri)
            const enabled = res.data.value === '1'
            setAiEnabled(enabled)
            // Suitable/Not Suitable are meaningless (and return nothing) once AI
            // is off — don't leave the view stuck on a filter carried over from
            // a previous session where AI was enabled.
            if (!enabled && (filterType === 'suitable' || filterType === 'notsuitable')) {
                setFilterType('full')
            }
        } catch (e) {
            showAlertError('Unknown Error - get AI Enabled')
        }
    }

    const updateListWithScroll = (newList, clearScroll = false) => {
        let newScrollY = 0
        if (!clearScroll) {
            const rows = document.querySelectorAll('.feedContentRow')
            if (rows.length) {
                let scrollOffsetY = 0
                for (let i = 0; i < rows.length; i++) {
                    const rowId = parseInt(rows[i].getAttribute('data-id'))
                    if (newList.findIndex(item => item.id == rowId) === -1) {
                        scrollOffsetY += rows[i].getBoundingClientRect().height + 10
                    }
                }
                newScrollY = window.scrollY - scrollOffsetY
            }            
        }
                
        setList(newList)
        scrollYRef.current = newScrollY
    }
    
    useLayoutEffect(() => {
        if (scrollYRef.current) {
            window.scrollTo(0, scrollYRef.current)
        }
        scrollYRef.current = 0
    }, [list])

    const getList = async (nextPage = false) => {
        if (nextPage) {
            if (loadingNextPage) {
                return
            }
            loadingNextPage = true
        } else {
            setAppendAfterReload(0)
        }
        
        storage.contents.filterTags = filterTags;
        storage.contents.filterSearch = filterSearch;
        storage.contents.filterFrom = filterFrom ? filterFrom : null;
        storage.contents.filterTo = filterTo ? filterTo : null;
        storage.contents.filterType = filterType;
        storage.contents.filterReadability = filterReadability;
        storage.contents.test = test;
        
        let uri = '';

        uri = getBackendUrl(endpoints.feedcontents, token);
        uri = uri.replace('{id}', rssId);
        
        const params = {}
        params.page = 0
        params.perpage = 5
        if (sessionStartId || nextPage) {
            if (nextPage) {
                if (list) {
                    params.start_id = list[list.length - 1]?.id
                } else {
                    params.start_id = null
                }
            } else {
                params.start_id = sessionStartId
            }
        }
        
        if (filterTags.length) {
            params.tags = filterTags.filter((item) => {
                return item.indexOf('t_') === 0
            }).map((item) => {
                return item.substring(2)
            }).join(',')
            
            params.notes = {}
            
            params.notes.owners = filterTags.filter((item) => {
                return item.indexOf('o_') === 0
            }).map((item) => {
                return item.substring(2)
            }).join(',')
            
            params.notes.profiles = filterTags.filter((item) => {
                return item.indexOf('p_') === 0
            }).map((item) => {
                return item.substring(2)
            }).join(',')
            
            params.notes.sent = filterTags.filter((item) => {
                return item.indexOf('s_') === 0
            }).map((item) => {
                return item.substring(2)
            }).join(',')
        }
        if (filterSearch) {
            params.filter = filterSearch
        }
        if (filterFrom) {
            if (filterFrom.$y) {
                let y = filterFrom.$y
                let m = filterFrom.$M + 1
                if (m < 10) {
                    m = '0' + m
                }
                let d = filterFrom.$D
                if (d < 10) {
                    d = '0' + d
                }
                params.datefrom = y + '-' + m + '-' + d
            }
        }
        if (filterTo) {
            if (filterTo.$y) {
                let y = filterTo.$y
                let m = filterTo.$M + 1
                if (m < 10) {
                    m = '0' + m
                }
                let d = filterTo.$D
                if (d < 10) {
                    d = '0' + d
                }
                params.dateto = y + '-' + m + '-' + d
            }
        }
        
        if (filterReadability) {
            params.readability = filterReadability
        }
        
        params.type = filterType        
        params.test = false  // !!!!!!!!!!!!!!!!!!!

        try {
            const res = await axios.get(uri, {params: params})
            
            setTotal(res.data.total)
            if (!nextPage) {
                updateListWithScroll(res.data.items, true)
            } else {
                if (list) {
                    updateListWithScroll([
                        ...list,
                        ...res.data.items
                    ])
                } else {
                    updateListWithScroll(res.data.items)
                }
            }
            if (!nextPage) {
                setViewContentId(null)
            }
            
            loadingNextPage = false
            loadingFinish = (res.data?.items?.length < params.perpage)
        } catch (err) {
            console.log(err)
            loadingNextPage = false
            if (nextPage) {
                loadingFinish = true
            }
            showAlertError('Unknown Error - get Feed contents list')
        }
    }

    const reloadItemHandle = async (id) => {
        if (id) {
            const uri = getBackendUrl(endpoints.feedcontents_refresh_data, token).replace('{id}', id)
            try {
                const res = await axios.get(uri)
                const feed = res.data?.feed
                if (feed) {
                    const tmp = list.map((item) => {
                        if (item.id === feed.id) {
                            item.notes = feed.notes
                            item.tags = feed.tags
                            item.covers = feed.covers
                            item.ext_read_at = feed.read_at
                        }
                        return item
                    })
                    setList(tmp)
                }
            } catch (err) {
                showAlertError('Unknown Error - get Feed Content Refresh Data')
            }
        }
    }
    
    const setAsRead = async (ids) => {
        if (ids.length) {
            const uri = getBackendUrl(endpoints.feedcontents_read, token)
            try {
                const res = await axios.put(uri, {
                    ids: ids.join(',')
                })
            } catch (err) {
                showAlertError('Unknown Error - put Set As Read')
            }
        }
    }

    const markUnreadHandler = async (id) => {
        const uri = getBackendUrl(endpoints.feedcontents_unread, token)
        try {
            await axios.put(uri, {
                ids: [id].join(',')
            })
            setList((prev) => prev?.map((item) => {
                if (item.id === id) {
                    item.read_at = null
                    item.ext_read_at = null
                }
                return item
            }))
        } catch (err) {
            showAlertError('Unknown Error - put Set As Unread')
        }
    }

    const markReadHandler = async (id) => {
        const uri = getBackendUrl(endpoints.feedcontents_read, token)
        try {
            await axios.put(uri, {
                ids: [id].join(',')
            })
            setList((prev) => prev?.map((item) => {
                if (item.id === id) {
                    item.read_at = new Date()
                }
                return item
            }))
        } catch (err) {
            showAlertError('Unknown Error - put Set As Read')
        }
    }
    
    const feedsUpdatedHandler = () => {
        window.scrollTo(0, 0)
        if (applyBtn.current) {
            applyBtn.current.click()
        }
    }
    
    const getFeed = async () => {
        try {
            const uri = getBackendUrl(endpoints.feeds_ext_one, token).replace('{id}', rssId);
            const res = await axios.get(uri)
            
            let feedTmp = res.data.feed
            
            setFeed(feedTmp)
        } catch (e) {
            setFeed(null)
            showAlertError('Unknown Error - get Feed One')
        }
    }
    
    const saveFeedHandle = (data) => {
        setFeedItem(null)
        getFeed()
        
        // Dispatch for update
        window.dispatchEvent(new Event('FEEDS_UPDATED'));
    }
        
    const loadFeedsHandle = async (response) => {
        setLoadFeeds(false);
        if (response) {
            setLoading(true)
            try {
                // Get All Feeds
                let uri = getBackendUrl(endpoints.run_job_feed, token).replace('{id}', feed.id);
                let res = await axios.get(uri);
                let count = res.data.items.length;
                
                showAlertSuccess('Feed loaded successfully! Loaded ' + count +' items')
                
                // Dispatch for update
                window.dispatchEvent(new Event('FEEDS_CONTENTS_UPDATED'));
            } catch (e) {
                showAlertError('Unknown Error - Load Feed')
                console.log(e);
            }
            setLoading(false)
        }
    }

    const showAlertError = (message) => {
        props.showAlert(message, 'error')
    }

    const showAlertSuccess = (message) => {
        props.showAlert(message, 'success')
    }
    
    const feedUpdateHandler = (event) => {
        if (event.detail == rssId) {
            setFeedItem(null)
            getFeed()
        }
    }
    
    const feedDeletedHandler = (event) => {
        if (event.detail == rssId) {
            setShowInformation('This Feed has been Deleted')
        }
    }
    
    const contentsUpdatedHandler = (event) => {
        setWssUpdateContents(event.detail || [])
    }
    
    const tagsUpdateHandler = () => {
        getTagsList()
    }
    
    const loadRssAppendedHandler = (event) => {
        if (event.detail) {
            const nc = parseInt(event.detail['f' + rssId] ?? 0)
            if (nc) {
                setAppendAfterReload((prev) => {
                    const newVal = prev + nc
                    if (newVal > 0) {
                        return newVal
                    }
                    return prev
                })
            }
        }
    }
    
    const scrollHandler = (event) => {
        clearTimeout(scrollTimeout)
        
        scrollTimeout = setTimeout(function () {            
            const rows = document.querySelectorAll('.feedContentRow')
            if (rows.length) {
                for (let i = 0; i < rows.length; i++) {
                    const rect = rows[i].getBoundingClientRect()
                    if (rect.bottom > HEADER_HEIGHT) {
                        setViewContentId(parseInt(rows[i].getAttribute('data-id')))
                        return
                    }
                }
            }
            setViewContentId('end')
        }, 250)
                
        setScrollUpBtn(window.scrollY > 100)
    }
    
    useEffect(() => {
        if (viewContentId && !loadingNextPage && list) {
            let viewIndex = 0
            if (viewContentId !== 'end' || loadingFinish) {
                viewIndex = list?.findIndex(item => item.id == viewContentId)
            } else {
                viewIndex = list.length - 1
            }
            
            if (viewIndex > -1 && viewIndex >= list.length - 2 && !loadingFinish) {
                getList(true)
            } else {
                const readIds = list.filter(item => {
                    return (viewContentId === 'end' || item.id > viewContentId) && !item.read_at
                }).map(item => item.id)
                setAsRead(readIds)

                if (filterReadability === 'unread') {
                    if (viewIndex === -1) {
                        setTotal(0)
                        updateListWithScroll([])
                    } else {
                        const newList1 = list.filter((item) => item.id <= viewContentId)
                        const d = list.length - newList1.length
                        setTotal(total - d)
                        updateListWithScroll(newList1)
                    }
                } else {
                    const newList2 = list.map((item, index) => {
                        if ((item.id > viewContentId || viewContentId === 'end') && !item.read_at) {
                            item.read_at = new Date()
                        }
                        return item
                    })
                    updateListWithScroll(newList2)
                }
            }
        }
    }, [viewContentId])
    
    useEffect(() => {
        if (wssUpdateContents?.length && list?.length) {
            const newList = list.map(item => {
                const wssItem = wssUpdateContents.find(w => w.id == item.id)
                if (wssItem) {
                    if (wssItem.read_at) {
                        item.ext_read_at = wssItem.read_at
                    }
                    item.notes = wssItem.notes
                    item.tags = wssItem.tags
                }
                return item
            })
            setWssUpdateContents([])
            setList(newList)
        }
    }, [wssUpdateContents, list])
    
    useEffect(() => {
        getTagsList()
        getSuitableThreshold()
        getAiEnabled()

        window.addEventListener('FEEDS_CONTENTS_UPDATED', feedsUpdatedHandler)
        window.addEventListener('FEED_UPDATED', feedUpdateHandler)
        window.addEventListener('FEED_DELETED', feedDeletedHandler)
        window.addEventListener('CONTENTS_UPDATED', contentsUpdatedHandler)
        window.addEventListener('TAGS_UPDATED', tagsUpdateHandler)
        window.addEventListener('LOAD_RSS_APPENDED', loadRssAppendedHandler)
        window.addEventListener('scroll', scrollHandler)
        
        return () => {
            window.removeEventListener('FEEDS_CONTENTS_UPDATED', feedsUpdatedHandler)
            window.removeEventListener('FEED_UPDATED', feedUpdateHandler)
            window.removeEventListener('FEED_DELETED', feedDeletedHandler)
            window.removeEventListener('CONTENTS_UPDATED', contentsUpdatedHandler)
            window.removeEventListener('TAGS_UPDATED', tagsUpdateHandler)
            window.removeEventListener('LOAD_RSS_APPENDED', loadRssAppendedHandler)            
            window.removeEventListener('scroll', scrollHandler)
        }
    }, []);

    useEffect(() => {
        getList()
    }, [feed, filterType, filterReadability, test]);
    
    useEffect(() => {
        dispatch(clearHeader())
        sessionStartId = null
        setList(null)
        setViewContentId(null)
        if (rssId) {
            getFeed()
        }
    }, [rssId])
    
    useEffect(() => {
        dispatch(setHeader({
            title: feed?.name,
            content: (
                <Stack
                    spacing={2}
                    direction="row"
                    alignItems="center"
                    sx={{
                        ml: 2,
                        mt: -1,
                        mb: -1,
                        flexGrow: 1,
                        // Compact toolbar group so the actions read as one control.
                        '& .MuiButton-root': {
                            borderRadius: '8px',
                            padding: '4px 8px',
                            fontSize: 12,
                            fontWeight: 600,
                            lineHeight: 1.2,
                            minWidth: 0,
                            color: 'text.secondary',
                        },
                        '& .MuiSvgIcon-root': {
                            fontSize: 20,
                        },
                    }}
                >
                    <Stack direction="row" spacing={0.25} alignItems="center">
                        {feed ?
                        <Tooltip arrow title="Edit Feed">
                            <Button onClick={() => {setFeedItem(feed)}} startIcon={<EditIcon/>}>
                                Edit
                            </Button>
                        </Tooltip>
                        : null }
                        <Tooltip arrow title="Fetch New Jobs From Upwork">
                            <Button onClick={() => {setLoadFeeds(true)}} startIcon={<DownloadIcon />}>
                                Fetch
                            </Button>
                        </Tooltip>
                        <Tooltip arrow title="Reload List">
                            <Button onClick={() => {getList()}} startIcon={
                                <Badge
                                    badgeContent={appendAfterReload}
                                    color="error"
                                    overlap="circular"
                                    sx={{
                                        '& .MuiBadge-badge': {
                                            fontSize: 10,
                                            fontWeight: 700,
                                            minWidth: 16,
                                            height: 16,
                                            border: '2px solid #fff',
                                        },
                                    }}
                                >
                                    <RefreshIcon />
                                </Badge>
                            }>
                                Reload
                            </Button>
                        </Tooltip>
                    </Stack>
                    <Stack direction="row" spacing={1} alignItems="center" sx={{ width: 140 }}>
                        <Tooltip arrow title="Preview length">
                            <Typography sx={{ fontSize: 12, fontWeight: 600, color: 'text.secondary', whiteSpace: 'nowrap' }}>
                                Preview:
                            </Typography>
                        </Tooltip>
                        <Slider
                            size="small"
                            min={1}
                            max={10}
                            step={1}
                            value={previewLines}
                            onChange={(e, value) => {
                                setPreviewLines(value)
                                storage.contents.previewLines = value
                                localStorage.setItem('contentsPreviewLines', value)
                            }}
                            sx={{ flexGrow: 1 }}
                        />
                    </Stack>
                </Stack>
            )
        }))
    }, [feed, list, appendAfterReload, previewLines])
    
    useEffect(() => {
        const startId = searchParams.get('startId')
        if (startId) {
            //getList()
           
            const newSearchParams = new URLSearchParams(searchParams);
            newSearchParams.delete('startId');
            
            navigate({
                pathname: window.location.pathname,
                search: newSearchParams.toString()
            }, { replace: true });
        }
    }, [searchParams, navigate])

    const filterTagsHandle = (value) => {
        setFilterTags((prev) => {
            // Sent not sent  -------------------------------------------
            const s_prev = prev.filter(item => item.indexOf('s_') === 0)
            const s_new = value.filter(item => item.indexOf('s_') === 0)

            if (s_new.length == 2) {
                let s_ok = ''
                if (s_prev[0] === 's_sent') {
                    s_ok = 's_notsent'
                } else {
                    s_ok = 's_sent'
                }

                return value.filter((item) => {
                    if (item.indexOf('s_') === 0) {
                        return item === s_ok
                    } else {
                        return true
                    }
                })
            }
            // ----------------------------------------------------------

            return value
        })
    }

    return (
        <Fade in={list ? true : false}>
            <Stack sx={{ maxWidth: 1200, margin: 'auto', overflow: 'hidden' }}>
                <Paper sx={{ p: 1.5, mb: 1.5 }}>
                <Grid container spacing={1.25} alignItems="center">
                    <Grid item lg={6} sm={6} xs={12}>
                        <FormControl variant="outlined" size="small" sx={{ width: '100%'}}>
                            <InputLabel id="tagsFilterLabel">Owners + Profiles + Sent + Tags</InputLabel>
                            <Select
                                fullWidth
                                labelId="tagsFilterLabel"
                                label="Owners + Profiles + Sent + Tags"
                                value={filterTags}
                                onChange={(e) => filterTagsHandle(e.target.value)}
                                multiple
                                renderValue={(selected, key) => (
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                        {selected.map((value, key) => (
                                            <Chip key={key} label={tagsList.find((item) => {
                                                return item.id && item.id == value
                                            })?.name ?? withoutTagsLabel} size="small"/>
                                        ))}
                                    </Box>
                                )}
                            >
                                {tagsList.map((row, key) => {
                                    if (row?.type === 'subheader') {
                                        return (
                                            <ListSubheader key={key}>{row.name}</ListSubheader>
                                        )
                                    } else {
                                        return (
                                            <MenuItem key={key} value={row?.id} sx={{p:0, pl:1, pr:1}}>
                                                {row?.type !== 'sent' 
                                                ? <Checkbox checked={filterTags.indexOf(row?.id) > -1} />
                                                : <Radio checked={filterTags.indexOf(row?.id) > -1} /> }
                                                <ListItemText primary={row?.name} />
                                            </MenuItem>
                                        )
                                    }
                                })}
                                <MenuItem key='empty' value='empty' sx={{p:0, pl:1, pr:1}}>
                                    <Checkbox checked={filterTags.indexOf('empty') > -1} />
                                    <ListItemText primary={withoutTagsLabel} />
                                </MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item lg={2} sm={6} xs={12}>
                        <TextField
                            variant="outlined"
                            size="small"
                            sx={{ width: '100%' }}
                            label="Search"
                            defaultValue={filterSearch}
                            onChange={(e) => {setFilterSearch(e.target.value)}}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon sx={{ fontSize: 18, color: 'text.disabled' }} />
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </Grid>
                    <Grid item lg={'auto'} sm={6} xs={12}>
                        <Stack spacing={1.25} direction="row">
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    label="Date From"
                                    sx={{ width: '152px' }}
                                    slotProps={{ textField: { variant: 'outlined', size: 'small' }, actionBar: { actions: ['clear'] } }}
                                    onChange={setFilterFrom}
                                    defaultValue={filterFrom}/>
                                <DatePicker
                                    label="Date To"
                                    sx={{ width: '152px' }}
                                    slotProps={{ textField: { variant: 'outlined', size: 'small' }, actionBar: { actions: ['clear'] } }}
                                    onChange={setFilterTo}
                                    defaultValue={filterTo}/>
                            </LocalizationProvider>
                        </Stack>
                    </Grid>

                    <Grid item xs={12}>
                        <Divider sx={{ mb: 1.25 }} />
                        <Stack
                            alignItems="center"
                            direction="row"
                            spacing={2}
                            useFlexGap
                            flexWrap="wrap"
                            sx={{ justifyContent: 'space-between' }}
                        >
                            {aiEnabled ?
                            <ToggleButtonGroup
                                exclusive
                                size="small"
                                value={filterType}
                                onChange={(e, value) => {
                                    // `exclusive` hands back null when the active button is clicked again.
                                    if (value !== null) {
                                        setFilterType(value)
                                    }
                                }}
                            >
                                <ToggleButton value="full">All Feed Data</ToggleButton>
                                <ToggleButton value="suitable">Suitable</ToggleButton>
                                <ToggleButton value="notsuitable">Not Suitable</ToggleButton>
                            </ToggleButtonGroup>
                            : null}

                            <FormControlLabel control={
                                <Checkbox
                                    size="small"
                                    onChange={(e) => {setFilterReadability(e.target.checked ? 'unread' : 'all')}}
                                    checked={filterReadability === 'unread'}
                                    sx={{mr:1}}
                                />
                            } label="Unread only" sx={{ mr: 0, '& .MuiFormControlLabel-label': { fontSize: 14 } }} />
                        </Stack>
                    </Grid>
                </Grid>
                </Paper>
                <ErrorBoundary resetKey={rssId}>
                <FeedContentsTable
                    items={list}
                    total={total}
                    previewLines={previewLines}
                    suitableThreshold={suitableThreshold}
                    onReloadItem={(id) => {reloadItemHandle(id)}}
                    onMarkUnread={(id) => {markUnreadHandler(id)}}
                    onMarkRead={(id) => {markReadHandler(id)}}
                    loadingFinish={loadingFinish}
                    owner={'feeds|' + rssId}
                    headerContent={
                        (<Stack direction="row" spacing={2} sx={{flexGrow:1}}>
                            <Tooltip arrow title="Reload List">
                                <IconButton size="small" onClick={() => {getList()}}>
                                    <Badge
                                        badgeContent={appendAfterReload}
                                        color="error"
                                        overlap="circular"
                                        sx={{
                                            '& .MuiBadge-badge': {
                                                fontSize: 10,
                                                fontWeight: 700,
                                                minWidth: 16,
                                                height: 16,
                                                border: '2px solid #fff',
                                            },
                                        }}
                                    >
                                        <RefreshIcon sx={{ fontSize: 18 }} />
                                    </Badge>
                                </IconButton>
                            </Tooltip>
                            <Stack sx={{flexGrow:1}}/>
                        </Stack>)
                    }
                />
                </ErrorBoundary>

                {!loadingFinish ?
                <Box sx={{ m:2, display: 'flex', width: '100%', justifyContent: 'center' }}>
                    <CircularProgress />
                </Box>
                : null }
                
                {list?.length ?
                <Box sx={{minHeight: 'calc(100vh - 80px)'}}></Box>
                : null }
                
                <Fade in={scrollUpBtn}>                    
                    <Tooltip arrow title="Scroll to top">
                        <Fab 
                            color="primary"
                            sx={{ position: 'fixed', right: 30, bottom: 30 }}
                            onClick={() => {
                                window.scrollTo({
                                    top: 0,
                                    behavior: 'smooth'
                                });
                            }}
                        >
                            <ArrowUpwardIcon />
                        </Fab>
                    </Tooltip>
                </Fade>
                
                {loading && <Loading />}
                
                <EditFeedModal 
                    dialogData={feedItem}
                    onClose={() => {setFeedItem(null)} }
                    onSave={saveFeedHandle}
                />
                <Confirmation data={loadFeeds} onResponse={loadFeedsHandle} />
                <Information text={showInformation} onClose={() => {navigate('/feeds')}}/>
            </Stack>
        </Fade>
    );
}

export default withAlert(FeedContents)
